


$('.single-slider .slide-list').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});



$('.category-list').slick({
  dots: false,
  arrows:true, 
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
        {
      breakpoint: 1400,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.explore-list').slick({
  dots: false,
  arrows:true, 
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



$('.home-tabs-slider .tab-slider-main').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
   responsive: [
     {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
});





  // // tabbed content
 
  // $(".tab-container .tab_content").hide();
  // // $(".tab-container .tab_content:first").show();
  // $('.tab-container').each(function (k, v) {
  //   $(v).find('.tab_content:first').show();
  // });

  // /* if in tab mode */
  // $("ul.tabs li").click(function () {
  //   var parent = $(this).parents('.tab-container');

  //   $(parent).find(".tab_content").hide();
  //   var activeTab = $(this).attr("rel");
  //   $(parent).find("#" + activeTab).fadeIn();

  //   $(parent).find("ul.tabs li").removeClass("active");
  //   $(this).addClass("active");

  //   $(parent).find(".tab_drawer_heading").removeClass("d_active");
  //   $(parent).find(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

  //   $('.tab-slider-main').slick('refresh');

  // });
  // /* if in drawer mode */
  // $(".tab_drawer_heading").click(function () {
  //   var parent = $(this).parents('.tab-container');

  //   $(parent).find(".tab_content").hide();
  //   var d_activeTab = $(this).attr("rel");
  //   $(parent).find("#" + d_activeTab).fadeIn();

  //   $(parent).find(".tab_drawer_heading").removeClass("d_active");
  //   $(this).addClass("d_active");

  //   $(parent).find("ul.tabs li").removeClass("active");
  //   $(parent).find("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
  // });


  // /* Extra class "tab_last"
  //    to add border to right side
  //    of last tab */
  // $('ul.tabs li').last().addClass("tab_last");



setTimeout(function() {
  $(".newsletter-form__field-wrapper-r").fadeOut().empty();
  $(".newsletter-form__field-wrapper-success").fadeOut().empty();
}, 5000);

var live_url = window.location.href;
var result = live_url.includes('newsletter&form_type=customer');
var thankyou = live_url.includes('customer_posted=true');

if(result){
    const add_ele = document.createElement("h3");
    add_ele.innerText = "Email ID Already Registered OR You Have Entered a Wrong Email!";
    document.querySelector('.newsletter-form__field-wrapper-r').appendChild(add_ele);
    add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
}else if(thankyou){
    const add_ele_success = document.createElement("h4");
    add_ele_success.innerText = "Success!";
    document.querySelector('.newsletter-form__field-wrapper-success').appendChild(add_ele_success);
    add_ele_success.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
}



